export default {
  nav: { models: "Models", gallery: "Gallery", fleet: "Fleet & B2B", contact: "Contact" },
  cta: { testDrive: "Book a test drive" },
  hero: {
    overline: "Official General Importer for Switzerland",
    title: "Electric into the future. Now in Switzerland.",
    subtitle: "Skyworth electric vehicles combine long range, state-of-the-art technology and honest Swiss support – from the test drive to servicing.",
    btnModels: "Discover the models",
  },
  stats: [
    { value: "30,000+", label: "Employees worldwide in the Skyworth Group" },
    { value: "7 years", label: "Manufacturer warranty on the BE11" },
    { value: "489 km", label: "WLTP range (BE11 Long Range)" },
    { value: "100%", label: "Support directly from Switzerland" },
  ],
  showcase: {
    overline: "Models",
    title: "A model for every requirement.",
    allLink: "All models in detail",
    discover: "Discover",
  },
  brand: {
    overline: "The brand",
    title: "From electronics group to e-mobility pioneer.",
    text: "Skyworth is a global technology group with over 30,000 employees – from consumer electronics to intelligent energy solutions. With Skywell, the brand brings this know-how to the road: robustly built electric vehicles with generous equipment and strong warranties.",
    bullets: [
      "Founded in 2000 – more than two decades of experience",
      "Vehicles in service across Europe, Asia and Australia",
      "Auto + Home: from the vehicle to energy solutions for your home",
    ],
  },
  videoSection: {
    overline: "Film",
    title: "Skyworth in motion.",
    text: "Experience the design, technology and driving feel of the Skyworth model range in the official brand film.",
  },
  fleetHome: {
    overline: "Fleet & B2B",
    title: "Electric mobility for your business.",
    text: "From a single company car to an entire fleet: we advise you personally on vehicle choice, charging infrastructure and operation – with a direct line to the manufacturer and service from Switzerland.",
    button: "Make a fleet enquiry",
  },
  service: {
    overline: "Service & trust",
    title: "Your point of contact in Switzerland.",
    cards: [
      { title: "Official general importer", text: "Direct manufacturer access – no detours, with all the benefits for you." },
      { title: "Showroom & service in Switzerland", text: "Personal advice, test drives and maintenance right on site." },
      { title: "Warranty & spare parts on site", text: "7-year manufacturer warranty and Swiss spare parts supply." },
    ],
  },
  ctaSection: {
    title: "See for yourself – on a test drive.",
    text: "Experience range, quietness and driving pleasure live. We will get back to you within 24 hours with a proposed appointment.",
    btnPrimary: "Book a test drive now",
  },
  footer: {
    tagline: "Official general importer for Skyworth & Skywell electric vehicles in Switzerland. Showroom, service, warranty and spare parts – all on site.",
    navTitle: "Navigation",
    contactTitle: "Contact",
    rights: "SkyworthCars Switzerland. All rights reserved.",
    legal: "Imprint & privacy policy to follow.",
    youtube: "Skyworth Auto on YouTube",
  },
  galleryPage: {
    overline: "Gallery",
    title: "Big pictures. Every model.",
    subtitle: "Official vehicle photos and videos – choose a model and browse the gallery.",
    explore: "Explore model",
    videoTitle: "Video",
  },
  modelsPage: {
    overline: "Model range",
    title: "All Skyworth models for Switzerland.",
    subtitle: "From the efficient electric SUV to the luxury flagship – discover the model range with photos, technical data and equipment.",
    loading: "Loading models …",
  },
  detail: {
    back: "All models",
    testDrive: "Book a test drive",
    consult: "Request advice",
    about: "About this model",
    specs: "Technical data",
    disclaimer: "All information without guarantee. Subject to change and errors excepted.",
    photos: "Photos & impressions",
    videoSoon: "Video section: official model videos coming soon.",
    ctaTitle: "Experience the {{name}} live?",
    ctaBtn: "Arrange a test drive",
    notFound: "Model not found",
    notFoundBack: "Back to model overview",
    loading: "Loading …",
  },
  testDrivePage: {
    overline: "Test drive",
    title: "Book your test drive.",
    subtitle: "Choose your preferred model and date – we will get back to you within 24 hours with a confirmation.",
  },
  contactPage: {
    overline: "Contact",
    title: "We are here for you.",
    subtitle: "Questions about a model, availability or service? Write to us or call us directly.",
    directTitle: "Direct contact",
    showroomTitle: "Showroom & service",
    hours: "Opening hours on request",
  },
  fleetPage: {
    overline: "Fleet & B2B",
    title: "Your fleet. Electric. Swiss-supported.",
    subtitle: "Reduce operating costs and emissions – with Skyworth electric vehicles, personal advice and reliable service directly from Switzerland.",
    scrollBtn: "Make an enquiry",
    cards: [
      { title: "Fleet solutions", text: "From a single company car to an entire fleet – tailored offers for Swiss businesses." },
      { title: "Charging infrastructure", text: "Advice on charging solutions at your company site and Vehicle-to-Load for mobile use." },
      { title: "Service partnership", text: "Direct line to the general importer: warranty handling, spare parts and maintenance from a single source." },
    ],
    vans: {
      overline: "Commercial vehicles",
      title: "For your logistics too: the Skyworth HONGTU Cargo Van.",
      text: "Electric vans and commercial vehicles for urban delivery – available for your fleet on request.",
      button: "Technical data & details of the HONGTU V9",
      cargoLabel: "HONGTU Cargo Van · Goods transport",
      passengerLabel: "HONGTU Passenger Van · Passenger transport",
    },
    formSection: { overline: "Fleet enquiry", title: "Tell us about your needs." },
    personal: "Prefer to talk in person?",
    personalLink: "Arrange a test drive for your team",
  },
  form: {
    name: "Name",
    email: "Email",
    phone: "Phone",
    company: "Company",
    model: "Model",
    modelPlaceholder: "Choose a model (optional)",
    consultation: "Advice requested",
    date: "Preferred date",
    message: "Message",
    messagePlaceholder: "Your message to us …",
    namePlaceholder: "First and last name",
    privacy: "By submitting, you agree that we may contact you regarding your enquiry.",
    submitProbefahrt: "Request test drive",
    submitKontakt: "Send message",
    submitFlotte: "Send fleet enquiry",
    sending: "Sending …",
    successProbefahrt: "Thank you! We will get back to you within 24 hours about your test drive.",
    successKontakt: "Thank you for your enquiry! We will get back to you as soon as possible.",
  },
  status: {
    available: "Available",
    orderable: "Orderable",
    soon: "Coming soon",
    onRequest: "On request",
  },
  priceOnRequest: "Price on request",
  models: {
    be11: {
      category: "Electric SUV",
      tagline: "The all-electric SUV – going electric made easy.",
      description: "The Skywell BE11 makes switching to electric effortless: long range, fast charging and more than 30 intelligent assistance systems. Plus a spacious, high-quality interior and equipment that leaves nothing to be desired – from the 360° camera to the panoramic sunroof.",
      features: [
        "12.8\" touchscreen + 12.3\" digital driver display",
        "Apple CarPlay & Android Auto (wireless)",
        "360° surround-view camera & parking assist",
        "Over 30 driver assistance systems (ADAS): incl. ACC, AEB, LKA, RCTA",
        "Panoramic sunroof (opening)",
        "Heated & ventilated front seats with memory function",
        "Wireless smartphone charging, 230 V socket (V2L)",
        "Electric tailgate with hands-free opening",
      ],
      specs: [
        ["Battery", "72 kWh / 86 kWh"],
        ["Range (WLTP)", "up to 489 km"],
        ["Power", "150 kW (204 hp) / 320 Nm"],
        ["DC fast charging", "up to 80 kW (10–80% in approx. 36–45 min)"],
        ["AC charging", "11 kW"],
        ["Drive", "Front-wheel drive"],
        ["Length × width × height", "4,720 × 1,908 × 1,696 mm"],
        ["Wheelbase", "2,800 mm"],
        ["Boot capacity", "689–1,608 litres"],
        ["Vehicle-to-Load (V2L)", "Yes – 230 V socket on board"],
        ["Infotainment", "12.8\" touchscreen + 12.3\" driver display"],
        ["Sound system", "Metz® with 8 speakers & subwoofer"],
        ["Warranty", "7-year manufacturer warranty"],
      ],
    },
    "ht-i": {
      category: "Plug-in hybrid SUV",
      tagline: "Electric in everyday life, carefree on long journeys.",
      description: "The Skyworth HT-i combines an efficient 1.5-litre engine with a powerful electric drive. In everyday driving you run purely electric – on trips the hybrid drive delivers a total range of up to 1,267 km. The ideal vehicle for everyone who wants flexibility without charging planning.",
      features: [
        "Purely electric driving in everyday use",
        "No charging planning needed on long distances",
        "Spacious SUV interior",
        "Modern infotainment & assistance systems",
      ],
      specs: [
        ["Drive", "Plug-in hybrid (1.5 l + electric motor)"],
        ["Total range", "up to 1,267 km (manufacturer figure)"],
        ["Pure electric range", "up to approx. 200 km (manufacturer figure)"],
        ["Body", "5-door SUV, 5 seats"],
        ["Warranty", "Manufacturer warranty – details on request"],
      ],
    },
    ce11: {
      category: "Electric luxury SUV",
      tagline: "Luxury and dignity – the flagship of the Skyworth model range.",
      description: "The Skyworth CE11 redefines electric luxury: a generous panoramic interior, a concealed curved ceiling screen and 21 speakers create an immersive experience. With Smart AI (Swaiot GPT), the vehicle becomes an intelligent companion.",
      features: [
        "Generous panoramic interior",
        "Concealed curved ceiling screen",
        "21 speakers for an immersive sound experience",
        "Smart AI · Swaiot GPT voice assistant",
        "Luxurious materials and craftsmanship",
      ],
      specs: [
        ["Drive", "All-electric"],
        ["Body", "Luxury SUV"],
        ["Sound system", "21 speakers"],
        ["Further technical data", "coming soon"],
      ],
    },
    ev6: {
      category: "Electric SUV",
      tagline: "The proven electric SUV of the first Skyworth generation.",
      description: "The Skyworth EV6 is the proven electric SUV with which the brand conquered the international market. Proven technology, a generous interior with panoramic sunroof and the SKYLINK networking system make it a solid choice for entering electric mobility.",
      features: [
        "SKYLINK Intelligent Networking – car & home connected",
        "Panoramic sunroof",
        "L2.5 driving assistance with over 15 functions",
        "Immersive audio & video system",
        "Generous interior with flexible seating modes",
      ],
      specs: [
        ["Drive", "All-electric"],
        ["Battery", "60.2 kWh"],
        ["Range", "up to 434 km (NEDC)"],
        ["Acceleration 0–100 km/h", "6.7 s"],
        ["DC fast charging", "20–70% in ≤ 32 min"],
        ["Body", "5-door SUV, 5 seats"],
        ["Warranty", "Manufacturer warranty – details on request"],
      ],
    },
    hongtu: {
      category: "Electric van",
      tagline: "100% electric cargo van for professional logistics.",
      description: "The Skyworth HONGTU V9 is the all-electric van for urban logistics and last-mile delivery: up to 14 m³ of cargo volume, over 1,400 kg payload and up to 408 km of range. Thanks to 120 kW DC fast charging it is ready again in around 36 minutes – zero emissions, zero compromise.",
      features: [
        "Two body variants: L2H2 and L3H4",
        "Load floor width of 1,403 mm between the wheel arches",
        "Aerodynamic design (cd 0.29) for high efficiency",
        "DC fast charging for minimal downtime",
        "Ideal for urban logistics, trades and last mile",
        "Also available as Passenger Van (passenger version)",
      ],
      specs: [
        ["Drive", "All-electric, 150 kW (204 hp) / 370 Nm"],
        ["Battery", "up to 100.9 kWh (CATL)"],
        ["Range (WLTP)", "up to 408 km"],
        ["DC fast charging", "up to 120 kW (20–80% in approx. 36 min)"],
        ["Cargo volume", "9 m³ (L2H2) / 14 m³ (L3H4)"],
        ["Payload", "up to 1,464 kg"],
        ["Gross vehicle weight", "4,250 kg"],
        ["Length × width × height", "5,490–5,990 × 1,990 × 2,200–2,700 mm"],
        ["Drag coefficient", "cd 0.29"],
        ["Warranty", "Manufacturer warranty – details on request"],
      ],
    },
    "hongtu-passenger": {
      category: "Electric passenger van",
      tagline: "Space. Comfort. Efficiency – the electric shuttle van.",
      description: "The Skyworth HONGTU Passenger Van carries up to 17 people quietly and emission-free – ideal for hotel shuttles, airport transfers and company transport. With 2,025 mm of standing height, comfortable individual seats (optionally with massage function) and modern assistance technology, your group travels in comfort. The large battery and 120 kW fast charging keep downtime to a minimum.",
      features: [
        "Up to 17 seats for shuttle and group transport",
        "Comfortable individual seats, optionally with massage function",
        "Standing height of 2,025 mm – easy entry and exit",
        "Quiet, emission-free drive for hotel & city shuttles",
        "Modular platform: also available as Cargo Van",
      ],
      specs: [
        ["Drive", "All-electric, up to 150 kW (204 hp), rear-wheel drive"],
        ["Battery", "up to 100.9 kWh (CATL)"],
        ["Range (WLTP)", "up to approx. 408 km"],
        ["DC fast charging", "up to 120 kW (20–80% in approx. 36 min)"],
        ["Seats", "up to 17 (depending on configuration)"],
        ["Interior height", "2,025 mm standing height"],
        ["Infotainment", "12.8\" central display"],
        ["Assistance systems", "L2+ driver assistance (ADAS)"],
        ["Warranty", "Manufacturer warranty – details on request"],
      ],
    },
  },
};
